
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  flex:1;
  height:100%;
}

.event-card{
  display:flex;
  flex-direction:column;
  flex-grow:1;
  flex-shrink:0;
  font-family:var(--ff-display);
  background-color:var(--brand-dark-blue-900);
  background-image:linear-gradient(
    137.77deg,
    rgba(4, 30, 74, 0) 50%,
    rgba(141, 200, 232, 0.1)
  );
  box-shadow:0 0 40px 5px rgba(4, 30, 74, 0.1);
  position:relative;
  width:100%;
  height:100%;
  z-index:1;
  cursor:pointer;
  transition:transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.event-card:hover{
    transform:translateY(-10px);
    box-shadow:0 10px 20px 2px rgba(4, 30, 74, 0.6);
  }

.event-card .content{
    display:flex;
    flex-direction:column;
    justify-content:start;
    padding:var(--spacing-5);
  }

@media (min-width: 1024px){

.event-card .content{
      padding:var(--spacing-8)
  }
    }

.event-card .date,
  .event-card .time,
  .event-card .location{
    color:var(--outline-white);
    display:block;
  }

.event-card .date{
    font-family:var(--ff-bold);
    font-size:var(--fs-lg);
    line-height:calc(40 / 18);
  }

.event-card .time,
  .event-card .location{
    font-family:var(--ff-italic);
    font-size:var(--fs-base);
    line-height:calc(24 / 16);
    font-family:var(--ff-display);
  }

.event-card .title{
    --heading-color:var(--brand-white);

    margin-bottom:12px;
    margin-top:-6px;
    font-size:var(--fs-h3-small);
    line-height:var(--lh-h3-medium);
  }

@media (min-width: 1024px){

.event-card .title{
      font-size:var(--fs-h3);
      line-height:var(--lh-h2-small)
  }
    }

.event-card .title a,
      .event-card .title a:visited,
      .event-card .title a:hover,
      .event-card .title a:focus,
      .event-card .title a:active{
        color:var(--outline-white);
      }

.event-card .rule{
    border:solid var(--brand-green-900);
    border-width:8px 0 0;
    display:block;
    height:1px;
    padding:0;
    position:relative;
    text-align:left;
    width:100%;
    margin:10px 0 20px;
    border-radius:3px;
    border-top-width:3px;
    max-width:905px;
  }

.event-card .cta{
    flex-grow:1;
    display:flex;
    align-items:flex-end;
    margin-top:var(--spacing-3);
  }

img{
  max-width:100%;
  vertical-align:middle;
  object-fit:cover;
}
`;